import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["templateId", "category", "prompt", "action", "loginRedirectUrl"];
import { HubletOption } from 'signup-constants/signupData/HubletOption';
import { getApplicationDomain } from '../constants/apiEnvironments';
import { createQueryParamString, cleanupSignupSpecificQueryParams } from '../intents/linkUtils';
import { getRouteParams } from '../routing/getRouteParams';
import trimEmptyValuesFromObject from '../utils/trimEmptyValuesFromObject';
export const getChatSpotRedirect = () => {
  const {
    queryParams
  } = getRouteParams();
  const {
      templateId,
      category,
      prompt,
      action,
      loginRedirectUrl
    } = queryParams,
    remainingParams = _objectWithoutPropertiesLoose(queryParams, _excluded);
  if (loginRedirectUrl) {
    return loginRedirectUrl;
  }
  if (templateId) {
    Object.assign(remainingParams, {
      templateId
    });
  } else if (category) {
    Object.assign(remainingParams, {
      category
    });
  } else if (prompt) {
    Object.assign(remainingParams, {
      prompt
    });
  } else if (action) {
    Object.assign(remainingParams, {
      action
    });
  }
  const baseChatSpotRedirectUrl = `${getApplicationDomain(HubletOption.na1)}/chatspot`;
  const params = trimEmptyValuesFromObject(remainingParams);
  const cleanedParams = cleanupSignupSpecificQueryParams(params);
  const paramsString = createQueryParamString(cleanedParams);
  return `${baseChatSpotRedirectUrl}${paramsString ? `?${paramsString}` : ''}`;
};